import { createApiAction } from '@app/packages/api/utils'

export const postSubscription = (period_months: 1 | 3 | 6 | 12 = 1) =>
  createApiAction('postSubscription', dispatch =>
    dispatch<unknown>({ method: 'POST', endpoint: '/api/v2/subscription', body: JSON.stringify({ period_months }) })
  )

export const putSubscriptionCancel = () =>
  createApiAction('putSubscriptionCancel', dispatch => dispatch<unknown>({ method: 'PUT', endpoint: '/api/v2/subscription/cancel' }))

export const putSubscriptionRestore = () =>
  createApiAction('putSubscriptionRestore', dispatch => dispatch<unknown>({ method: 'PUT', endpoint: '/api/v2/subscription/restore' }))
